(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ LandingPageHeader; }
});

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js + 1 modules
var popover = __webpack_require__(9860);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(3587);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MenuIcon.js
var MenuIcon = __webpack_require__(9065);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./public/static/vrt-logos/vrt/svg/vrt-color.svg
var vrt_color = __webpack_require__(8832);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/ArrowRightIcon.js


function ArrowRightIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(ArrowRightIcon);
/* harmony default export */ var esm_ArrowRightIcon = (ForwardRef);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Header/LandingPageHeader.tsx








var LandingPageHeader = function LandingPageHeader() {
  var navigation = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Partner worden',
    href: '/partner-worden'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(popover/* Popover */.J, {
    className: "relative z-10",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mx-auto px-4 sm:px-6 bg-white border-b-2 border-b-white rounded-b-3xl drop-shadow-md",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between items-center py-4 md:justify-start md:space-x-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex justify-start lg:w-0 lg:flex-1",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: '/',
            passHref: true,
            className: "m-0 ",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(vrt_color/* default */.Z, {
                className: 'h-6 hover:cursor-pointer'
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "-mr-2 -my-2 md:hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
            className: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "sr-only",
              children: "Open menu"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuIcon/* default */.Z, {
              className: "h-6 w-6",
              "aria-hidden": "true"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(popover/* Popover.Group */.J.Group, {
          as: "nav",
          className: "hidden md:flex space-x-10",
          children: navigation.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: item.href,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "text-base font-medium text-gray-500 hover:text-gray-900",
                children: item.name
              })
            }, item.name);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden md:flex items-center justify-end md:flex-1 lg:w-0",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: '/portaal/aanbod',
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
              type: "button",
              className: "inline-flex items-center rounded-md border border-vrt-pink rounded-md px-4 py-2 gap-x-3 font-medium text-vrt-pink hover:bg-vrt-pink hover:text-white",
              children: ["Naar het portaal", /*#__PURE__*/(0,jsx_runtime.jsx)(esm_ArrowRightIcon, {
                className: 'h-5'
              })]
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* Transition */.u, {
      as: react.Fragment,
      enter: "duration-200 ease-out",
      enterFrom: "opacity-0 scale-95",
      enterTo: "opacity-100 scale-100",
      leave: "duration-100 ease-in",
      leaveFrom: "opacity-100 scale-100",
      leaveTo: "opacity-0 scale-95",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
        focus: true,
        className: "absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "pt-5 pb-6 px-5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center justify-between",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(vrt_color/* default */.Z, {
                  className: 'h-6'
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "-mr-2",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                  className: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    children: "Close menu"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                    className: "h-6 w-6",
                    "aria-hidden": "true"
                  })]
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
                className: "grid gap-y-8",
                children: navigation.map(function (item) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: item.href,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      className: "text-base font-medium text-gray-500 hover:text-gray-900",
                      children: item.name
                    })
                  }, item.name);
                })
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "py-6 px-5 space-y-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: '/portaal/aanbod',
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                  type: "button",
                  className: "w-full inline-flex items-center justify-center rounded-md border border-vrt-pink rounded-md px-4 py-2 gap-x-3 font-medium text-vrt-pink hover:bg-vrt-pink hover:text-white",
                  children: ["Naar het portaal", /*#__PURE__*/(0,jsx_runtime.jsx)(esm_ArrowRightIcon, {
                    className: 'h-5'
                  })]
                })
              })
            })
          })]
        })
      })
    })]
  });
};

/***/ }),

/***/ 3639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1336);
/* harmony import */ var _components_VrtBrandLogoBar_VrtBrandLogoBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9091);
/* harmony import */ var _components_Header_LandingPageHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(561);
/* harmony import */ var _components_SEO__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3259);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);









var Home = function Home() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_SEO__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      title: 'Kwalitatieve VRT-content op jouw platform',
      description: 'Krijg toegang tot clips uit de populairste VRT-programma’s en verrijk je klantenervaring met sterke mediacontent.'
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_Header_LandingPageHeader__WEBPACK_IMPORTED_MODULE_2__/* .LandingPageHeader */ .B, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: '-mt-10',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("aside", {
        className: "overflow-hidden bg-[url(/heroImage.jpeg)] bg-center bg-no-repeat bg-cover",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "p-8 md:p-12 lg:px-16 md:py-24 lg:py-36 bg-black/20",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "text-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h1", {
              className: "font-bold text-9xl 2xl:text-[200px] text-transparent",
              style: {
                WebkitTextStroke: '2px',
                WebkitTextStrokeColor: 'white'
              },
              children: "Open Media"
            })
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: "container max-w-7xl mx-auto px-6",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "py-8 lg:py-16 mx-auto text-center text-max-dark-blue",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: "pb-4",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h1", {
            className: "text-4xl font-semibold md:text-5xl lg:text-6xl ",
            children: "Kwalitatieve VRT-content op jouw platform"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            className: "text-2xl font-light lg:text-2xl sm:px-16 xl:px-48 text-max-dark-blue py-10",
            children: "VRT stelt via het Open Media-platform een deel van haar content ter beschikking zodat partners op een eenvoudige en kosteneffici\xEBnte manier hun apps of sites kunnen verrijken met clips of nieuws."
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: "space-y-8 md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-6 md:space-y-0 text-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h3", {
              className: "mb-2 text-2xl font-bold",
              children: "Dagelijks nieuwe content"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              className: "font-light text-xl dark:text-gray-400",
              children: "Krijg dagelijks toegang tot actuele content die er toe doet."
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h3", {
              className: "mb-2 text-2xl font-bold ",
              children: "VRT-kwaliteitslabel"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              className: "font-light text-xl",
              children: "VRT selecteert en biedt de meest interessante content aan."
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h3", {
              className: "mb-2 text-2xl font-bold ",
              children: "Op jouw maat"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              className: "font-light text-xl",
              children: "Eenvoudig te integreren in je eigen omgeving via onze embed codes en API\u2019s."
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("section", {
      className: "container max-w-7xl mx-auto px-6 bg-white py-6",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "text-center pb-5",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
          className: "font-semibold text-gray-400 uppercase",
          children: "Onze merken"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_VrtBrandLogoBar_VrtBrandLogoBar__WEBPACK_IMPORTED_MODULE_1__/* .VrtBrandLogoBar */ .$, {
        color: 'color'
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("section", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "px-4 py-16 mx-auto max-w-screen-xl sm:px-6 lg:px-8",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: "grid grid-cols-1 gap-8 lg:gap-16 lg:grid-cols-2",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "relative h-64 overflow-hidden rounded-lg sm:h-80 lg:h-full lg:order-last",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
              className: "absolute inset-0 object-cover w-full h-full",
              src: "/static/images/media-image-vrt.jpeg",
              alt: "VRT Open Media"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: "lg:py-24",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h2", {
              className: "text-3xl font-bold sm:text-4xl",
              children: "Dagelijks aanbod aan short form video"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              className: "mt-4 text-max-dark-blue text-lg font-light",
              children: "Krijg toegang tot clips uit de populairste VRT-programma\u2019s en verrijk je klantenervaring met sterke mediacontent."
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
              href: '/partner-worden',
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                className: "inline-flex items-center px-8 py-3 mt-8 text-white bg-indigo-600 border border-indigo-600 rounded hover:bg-transparent hover:text-indigo-600 active:text-indigo-500 focus:outline-none focus:ring",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("span", {
                  className: "font-medium",
                  children: [' ', "Partner worden", ' ']
                })
              })
            })]
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "px-4 py-8 mx-auto max-w-screen-xl sm:px-6 lg:px-8",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: "grid grid-cols-1 gap-8 lg:gap-16 lg:grid-cols-2",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "relative h-64 overflow-hidden rounded-lg sm:h-80 lg:h-full lg:order-first",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
              className: "absolute inset-0 object-cover w-full h-full",
              src: "/static/images/media-image-vrtnws.jpeg",
              alt: "Kunnen zijn wie je bent"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: "lg:py-24",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h2", {
              className: "text-3xl font-bold sm:text-4xl",
              children: "De hoogtepunten uit het nieuws"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              className: "mt-4 text-max-dark-blue text-lg font-light",
              children: "Bied je klanten de hoogtepunten van VRT NWS aan, het meest betrouwbare nieuwsmerk van het land. Integreer de feed van VRT NWS, Sporza, Karrewiet of nws.nws.nws in je app of op je site!"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
              href: '/partner-worden',
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                className: "inline-flex items-center px-8 py-3 mt-8 text-white bg-indigo-600 border border-indigo-600 rounded hover:bg-transparent hover:text-indigo-600 active:text-indigo-500 focus:outline-none focus:ring",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("span", {
                  className: "font-medium",
                  children: [' ', "Partner worden", ' ']
                })
              })
            })]
          })]
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_0__/* .Footer */ .$, {})]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3639);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [668,284,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);